// API validation exports
import { z } from 'zod';

export const PaginationSchema = z.object({
  page: z.number().min(1).default(1),
  limit: z.number().min(1).max(100).default(20)
});

export const SearchParamsSchema = z.object({
  query: z.string().min(1),
  mode: z.enum(['Latest', 'Top']).default('Latest'),
  maxTweets: z.number().min(1).max(1000).default(100)
});

export const UserIdSchema = z.object({
  userId: z.string().min(1)
});

export const ListIdSchema = z.object({
  listId: z.string().min(1)
});

export type PaginationParams = z.infer<typeof PaginationSchema>;
export type SearchParams = z.infer<typeof SearchParamsSchema>;
export type UserIdParams = z.infer<typeof UserIdSchema>;
export type ListIdParams = z.infer<typeof ListIdSchema>;